if (!customElements.get('tbh-product-offers')) {
  customElements.define('tbh-product-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelectorAll('[data-tbh-add-form]').forEach((form) => this.upgradeOptions(form));
      this.addEventListener('submit', (event) => this.addProduct(event));
      this.addEventListener('change', (event) => event.stopPropagation());
    }

    upgradeOptions(form) {
      const data = form.querySelector('[data-tbh-variants]');
      if (!data) return;
      let product;
      try { product = JSON.parse(data.textContent); } catch { return; }
      if (!product.options?.length || !product.variants?.length) return;
      const native = form.querySelector('select[name="id"]');
      const container = form.querySelector('[data-tbh-options]');
      const button = form.querySelector('[type="submit"]');
      const card = form.closest('.tbh-offer');
      const selected = product.options.map(() => '');
      const controls = product.options.map((name, index) => {
        const field = document.createElement('div');
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `${native.id}-option-${index}`;
        label.htmlFor = select.id;
        label.textContent = name;
        label.className = this.dataset.placement === 'pdp' ? '' : 'visually-hidden';
        select.required = true;
        select.dataset.optionIndex = index;
        field.append(label, select);
        container.append(field);
        return select;
      });
      form.dataset.readyLabel = button.textContent.trim();
      // Default only the clearly labelled color. A size always requires an explicit choice.
      if (/colou?r/i.test(product.options[0])) selected[0] = form.dataset.initialColor || product.variants[0].options[0];
      const update = () => {
        controls.forEach((select, index) => {
          const possible = product.variants.filter((variant) =>
            selected.every((value, earlier) => earlier >= index || !value || variant.options[earlier] === value));
          const values = [...new Set(possible.map((variant) => variant.options[index]))];
          if (!values.includes(selected[index])) selected[index] = '';
          select.replaceChildren();
          const placeholder = new Option(/size/i.test(product.options[index]) ? product.options[index] : `${form.dataset.tbhChoose} ${product.options[index]}`, '');
          placeholder.disabled = true;
          select.add(placeholder);
          values.forEach((value) => select.add(new Option(value, value)));
          select.value = selected[index];
        });
        const choices = product.variants.filter((variant) =>
          selected.every((value, index) => !value || variant.options[index] === value));
        const variant = selected.every(Boolean) ? choices[0] : null;
        native.value = variant ? String(variant.id) : '';
        button.disabled = !variant;
        const missing = product.options.filter((_, index) => !selected[index]);
        button.textContent = variant ? form.dataset.readyLabel : `${form.dataset.tbhChoose} ${missing.join(' / ')}`;
        const preview = variant || choices[0];
        if (!preview) return;
        const original = card.querySelector('[data-tbh-original-price]');
        card.querySelector('[data-tbh-current-price]').textContent = original ? preview.offerPrice : preview.price;
        if (original) original.textContent = preview.originalPrice;
        const image = card.querySelector('.tbh-offer__image img');
        if (image && preview.image) {
          image.srcset = '';
          image.src = this.dataset.preview === 'true' ? (preview.previewImage || preview.image) : preview.image;
          const previewTrigger = image.closest('[data-tbh-image-preview]');
          if (previewTrigger) previewTrigger.dataset.tbhImageSrc = preview.previewImage || preview.image;
        }
      };
      controls.forEach((select, index) => select.addEventListener('change', () => {
        if (this.dataset.busy) return;
        selected[index] = select.value;
        update();
        if (native.value && this.dataset.manual !== 'true') form.requestSubmit();
      }));
      update();
      native.required = false;
      form.querySelector('[data-tbh-native-variant]').hidden = true;
      container.hidden = false;
      const hint = this.querySelector('[data-tbh-auto-hint]');
      if (hint) hint.hidden = false;
      button.hidden = this.dataset.manual !== 'true';
      form.dataset.autoAdd = String(this.dataset.manual !== 'true');
    }

    async addProduct(event) {
      const form = event.target.closest('[data-tbh-add-form]');
      if (!form) return;
      event.preventDefault();
      if (!form.reportValidity() || form.dataset.busy || this.dataset.busy) return;
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[role="alert"]');
      const variantId = form.elements.id.value;
      if (!variantId) return;
      form.dataset.busy = 'true';
      this.dataset.busy = 'true';
      this.querySelectorAll('[data-tbh-options] select').forEach((select) => { select.disabled = true; });
      const readyLabel = button.textContent;
      button.textContent = form.dataset.tbhAdding;
      button.hidden = false;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const drawer = document.querySelector('cart-drawer');
      const pageItems = document.querySelector('cart-items');
      const sections = drawer?.getSectionsToRender().map((section) => section.id) || ['cart-icon-bubble'];
      const pageSections = pageItems?.getSectionsToRender() || [];
      pageSections.forEach((section) => sections.push(section.section));
      let addedSuccessfully = false;
      const EventType = window.StandardEvents?.CartLinesUpdateEvent;
      const eventDeferred = EventType?.createPromise();
      if (eventDeferred) {
        this.dispatchEvent(new EventType({
          action: 'add', context: this.dataset.placement === 'pdp' ? 'product' : 'cart',
          lines: [{ merchandiseId: variantId, quantity: 1 }], promise: eventDeferred.promise,
        }));
      }
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: [...new Set(sections)].slice(0, 5), sections_url: location.pathname }),
        });
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || added.message);
        addedSuccessfully = true;
        const cartResponse = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        if (cart?.currency && eventDeferred) eventDeferred.resolve({ cart: EventType.createCartFromAjaxResponse(cart) });
        else if (eventDeferred) eventDeferred.reject(new Error('Cart state unavailable'));
        let rendered = false;
        if (drawer && added.sections?.['cart-drawer']) {
          drawer.setActiveElement(button);
          drawer.renderContents(added);
          rendered = true;
        }
        pageSections.forEach((section) => {
          const target = document.getElementById(section.id);
          const html = added.sections?.[section.section];
          if (!target || !html) return;
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
          const destination = target.querySelector(section.selector) || target;
          if (source) { destination.innerHTML = source.innerHTML; rendered = true; }
        });
        if (!rendered) location.assign(window.routes.cart_url);
        else this.dispatchEvent(new CustomEvent('tbh:product-added', { bubbles: true }));
      } catch (failure) {
        eventDeferred?.reject(failure);
        if (addedSuccessfully) location.assign(window.routes.cart_url);
        else error.hidden = false;
      } finally {
        delete form.dataset.busy;
        delete this.dataset.busy;
        this.querySelectorAll('[data-tbh-options] select').forEach((select) => { select.disabled = false; });
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = readyLabel;
      }
    }
  });
}

// One delegated image viewer survives native cart section replacement.
if (!document.getElementById('TbhCartImagePreview')) {
  const imageDialog = document.createElement('dialog');
  imageDialog.id = 'TbhCartImagePreview';
  imageDialog.className = 'tbh-image-preview';
  imageDialog.setAttribute('aria-labelledby', 'TbhCartImagePreviewTitle');
  imageDialog.innerHTML = '<div class="tbh-image-preview__content"><header><h2 id="TbhCartImagePreviewTitle"></h2><button type="button" autofocus aria-label="Close image preview"><svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button></header><img alt="" decoding="async"></div>';
  document.body.append(imageDialog);
  const fullImage = imageDialog.querySelector('img');
  const imageTitle = imageDialog.querySelector('h2');
  const closeButton = imageDialog.querySelector('button');
  let imageTrigger = null;
  closeButton.addEventListener('click', () => imageDialog.close());
  imageDialog.addEventListener('click', (event) => {
    if (event.target === imageDialog) imageDialog.close();
  });
  imageDialog.addEventListener('cancel', (event) => event.stopPropagation());
  // Escape must dismiss only the top image layer, not the drawer's keyup handler.
  let suppressEscapeKeyup = false;
  window.addEventListener('blur', () => { suppressEscapeKeyup = false; });
  document.addEventListener('keyup', (event) => {
    if (suppressEscapeKeyup && event.code === 'Escape') {
      suppressEscapeKeyup = false;
      event.stopPropagation();
    }
  }, true);
  imageDialog.addEventListener('keydown', (event) => {
    if (event.code !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    suppressEscapeKeyup = true;
    imageDialog.close();
  });
  imageDialog.addEventListener('close', () => {
    fullImage.removeAttribute('src');
    const origin = imageTrigger?.isConnected ? imageTrigger : null;
    const drawer = document.querySelector('cart-drawer.active');
    if (drawer?.classList.contains('active') && typeof trapFocus === 'function') {
      trapFocus(document.getElementById('CartDrawer'), origin || drawer.querySelector('.drawer__close'));
    } else origin?.focus();
    imageDialog.querySelector('tbh-product-offers')?.remove();
    imageTrigger = null;
  });
  imageDialog.addEventListener('tbh:product-added', () => imageDialog.close());
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tbh-image-preview]');
    if (!trigger || !trigger.dataset.tbhImageSrc) return;
    event.preventDefault();
    imageTrigger = trigger;
    imageTitle.textContent = trigger.dataset.tbhImageTitle || 'Design preview';
    fullImage.alt = trigger.dataset.tbhImageTitle || 'T-shirt design preview';
    fullImage.src = trigger.dataset.tbhImageSrc;
    // Reuse the same variant and cart pipeline, with explicit submission in the preview.
    const sourceCard = trigger.closest('.tbh-offer');
    const sourceData = sourceCard?.querySelector('[data-tbh-variants]') || trigger.parentElement.querySelector('[data-tbh-native-preview-data] [data-tbh-variants]');
    imageDialog.querySelector('tbh-product-offers')?.remove();
    if (sourceData) {
      const product = JSON.parse(sourceData.textContent);
      const module = document.createElement('tbh-product-offers');
      module.className = 'tbh-offers tbh-offers--preview';
      module.dataset.placement = 'cart';
      module.dataset.manual = 'true';
      module.dataset.preview = 'true';
      module.innerHTML = '<article class="tbh-offer"><div class="tbh-offer__image"></div><div class="tbh-offer__content"><p class="tbh-offer__price"><strong data-tbh-current-price></strong></p><form data-tbh-add-form data-tbh-adding="Adding…" data-tbh-choose="Choose"><input type="hidden" name="quantity" value="1"><div data-tbh-native-variant hidden><select name="id" id="TbhPreviewVariant"></select></div><div class="tbh-offer__options" data-tbh-options hidden></div><script type="application/json" data-tbh-variants></script><button type="submit" class="button">Add to cart</button><p class="tbh-offer__error" role="alert" hidden>Could not add this tee. Please try again.</p></form></div></article>';
      module.querySelector('.tbh-offer__image').append(fullImage);
      const price = module.querySelector('.tbh-offer__price');
      if (sourceCard?.querySelector('[data-tbh-original-price]')) {
        const original = document.createElement('s');
        original.setAttribute('data-tbh-original-price', '');
        price.prepend(original);
      }
      module.querySelector('[data-tbh-variants]').textContent = sourceData.textContent;
      const native = module.querySelector('select[name="id"]');
      native.add(new Option('Choose variant', ''));
      product.variants.forEach((variant) => native.add(new Option(variant.options.join(' / '), String(variant.id))));
      module.querySelector('form').dataset.initialColor = sourceCard?.querySelector('[data-option-index="0"]')?.value || trigger.dataset.tbhInitialColor || '';
      imageDialog.querySelector('.tbh-image-preview__content').append(module);
    } else imageDialog.querySelector('.tbh-image-preview__content').append(fullImage);
    if (trigger.closest('cart-drawer') && typeof removeTrapFocus === 'function') removeTrapFocus();
    imageDialog.showModal();
  });
}

{
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    let previous = null;
    let pending = false;
    const animateReward = (element) => {
      if (!element) return;
      element.classList.add('tbh-reward-celebrate');
      element.addEventListener('animationend', () => element.classList.remove('tbh-reward-celebrate'), { once: true });
    };
    const updateRewards = () => {
      pending = false;
      const summary = drawer.querySelector('[data-tbh-saved-cents]');
      const current = {
        savings: Number(summary?.dataset.tbhSavedCents || 0),
        shipping: summary?.dataset.tbhFreeShipping === 'true',
      };
      if (previous) {
        if (current.savings > previous.savings) animateReward(summary?.querySelector('.bird-cart-summary__saved'));
        if (current.shipping && !previous.shipping) {
          animateReward(summary?.querySelector('[data-tbh-shipping-reward]'));
          animateReward(drawer.querySelector('.bird-shipping-progress.is-complete p'));
        }
      }
      previous = current;
    };
    updateRewards();
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(updateRewards);
    }).observe(drawer, { childList: true, subtree: true });
  }
}

document.addEventListener('click', (event) => {
  document.querySelectorAll('.tbh-shipping-info[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('.tbh-shipping-info[open]');
  if (!details) return;
  event.preventDefault();
  event.stopPropagation();
  details.open = false;
  details.querySelector('summary').focus();
});
document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.tbh-shipping-info[open]').forEach((details) => {
    if (!details.contains(event.target)) details.open = false;
  });
});
